module.exports = __webpack_public_path__ + "static/media/especies.23bea301.xlsx";